import { Companion_getInstance1gf57apoj2u0h as Companion_getInstance } from '../type/GraphQLBoolean.mjs';
import {
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance_0 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsMutationSelectionsClass;
function SavePairAssignmentsMutationSelections() {
  if (SavePairAssignmentsMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        SavePairAssignmentsMutationSelections_instance = this;
        this.w6g_1 = listOf((new (Builder())('savePairAssignments', Companion_getInstance().o6o_1)).s43(listOf((new (Builder_0())(Companion_getInstance_0().m6d_1)).d44(new (CompiledVariable())('input')).j37())).j37());
      }
    }
    initMetadataForObject($, 'SavePairAssignmentsMutationSelections');
    SavePairAssignmentsMutationSelectionsClass = $;
  }
  return SavePairAssignmentsMutationSelectionsClass;
}
var SavePairAssignmentsMutationSelections_instance;
function SavePairAssignmentsMutationSelections_getInstance() {
  if (SavePairAssignmentsMutationSelections_instance === VOID)
    new (SavePairAssignmentsMutationSelections())();
  return SavePairAssignmentsMutationSelections_instance;
}
//region block: exports
export {
  SavePairAssignmentsMutationSelections_getInstance as SavePairAssignmentsMutationSelections_getInstance19fjb3j0pmf0l,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsMutationSelections.mjs.map
